var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Divider } from "@mui/material";
import { t } from "i18next";
import { useEffect, useState } from "react";
import { EditableDataGrid } from "../../../builderPackage/components/editableDataGrid/editableDataGrid";
import { MuiButton, MuiStack } from "../../../components";
export var LocationMultiSelectPopUp = function (props) {
    var _a = props.selectedRows, selectedRows = _a === void 0 ? [] : _a, onSubmit = props.onSubmit, onClose = props.onClose, apiKey = props.apiKey, apiRequest = props.apiRequest, apiCall = props.apiCall, _b = props.columns, columns = _b === void 0 ? [] : _b, singleSelection = props.singleSelection, rowData = props.rowData, issueQuantity = props.issueQuantity;
    var _c = useState(), selected = _c[0], setSelected = _c[1];
    var _d = useState([]), rows = _d[0], setRows = _d[1];
    useEffect(function () {
        if (selectedRows !== null && selectedRows !== void 0 && selectedRows.length)
            setSelected(selectedRows);
        if (apiCall)
            getData(apiRequest);
    }, []);
    var getData = function (request) { return __awaiter(void 0, void 0, void 0, function () {
        var res, finalArray;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, apiCall({
                        request: request
                    })];
                case 1:
                    res = _a.sent();
                    finalArray = [];
                    if (res !== null && res !== void 0 && res.success) {
                        setRows(res === null || res === void 0 ? void 0 : res.data);
                        setSelected(selectedRows);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    return /*#__PURE__*/ React.createElement(MuiStack, {
        flexDirection: 'column',
        justifyContent: 'space-between'
    }, /*#__PURE__*/ React.createElement(Divider, {
        style: {
            paddingTop: '15px'
        }
    }), /*#__PURE__*/ React.createElement(MuiStack, {
        marginTop: '10px'
    }, /*#__PURE__*/ React.createElement(EditableDataGrid, {
        columns: columns,
        rows: rows,
        dataGridProps: {
            checkboxSelection: true,
            disableColumnSorting: true,
            disableColumnMenu: true,
            disableRowSelectionOnClick: true,
            disableColumnFilter: true,
            disableMultipleColumnsFiltering: true,
            disableMultipleColumnsSorting: true,
            disableMultipleRowSelection: singleSelection,
            rowSelectionModel: selected,
            onRowSelectionModelChange: function (rowSelectionModel, details) {
                setSelected(rowSelectionModel);
            }
        },
        validationModel: {
            IssueQuantity: function (value, row) {
                return value > (rowData === null || rowData === void 0 ? void 0 : rowData.RequestedQuantity) ? "Issue quantity cannot be more than requested quantity." : undefined;
            }
        }
    })), /*#__PURE__*/ React.createElement(MuiStack, {
        sx: {
            justifyContent: 'flex-end'
        }
    }, /*#__PURE__*/ React.createElement(MuiButton, {
        id: "cancelButton",
        name: t("Cancel"),
        style: {
            borderColor: "secondary.200",
            color: "secondary.600",
            fontSize: "lg",
            fontWeight: "medium",
            marginTop: "16px",
            padding: "20px",
            alignSelf: 'center',
            marginRight: '20px'
        },
        onClick: onClose
    }), /*#__PURE__*/ React.createElement(MuiButton, {
        id: "saveButton",
        name: t('Save'),
        variant: "contained",
        style: {
            fontSize: "lg",
            fontWeight: "medium",
            marginTop: "16px",
            padding: "20px",
            alignSelf: 'center'
        },
        onClick: function () {
            onSubmit && onSubmit(selected, rows);
            //onClose()
        }
    })));
};
